<template>
    <div class="dice-wrapper" v-if="(status!==-1)">
        <div v-if="(status === 0)" class="dice">
            <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
        <div v-else-if="(status === 1)" style="transition:all 0.6s" class="dice moving">
            <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
        <div v-else-if="(status === 2)" class="dice moving">
            <ul ref="dice">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
        <div class="panel" v-show="panel">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
import arr from './const'
export default {
    name: 'Dice',
    data() {
        return {
            status: -1, //-1 界面不显示 0 初始状态 1 移动状态  2 旋转状态
            panel: 0
        }
    },
    methods: {
        startGame(num) {
            return new Promise(resolve => {
                this.status = 0;
                setTimeout(() => {
                    this.status = 1;
                }, 100)
                setTimeout(() => {
                    this.status = 2;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            const find = arr.find(item=>item.id===num);
                            this.$refs.dice.style = find['pos'];
                            this.$refs.dice.addEventListener('transitionend', () => {
                                this.panel = 1;
                            })
                        }, 300)
                    })
                }, 700)
                setTimeout(() => {
                    this.panel = 0;
                    this.status = -1;
                    resolve(num)
                }, 3000)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.icon {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
    background-size: 20rem 20rem;
}

@keyframes Move {
    from {
        transform: perspective(2000px) rotateX(45deg) rotateY(45deg);
    }

    to {
        transform: perspective(2000px) rotateX(360deg) rotateY(360deg);
        opacity: 1;
    }
}

@keyframes Bigger {
    to {
        transform: scale(1.4);
        opacity: 0.2;
    }
}

.dice-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 5;
    left: 0rem;
    top: 0rem;
    background: rgba(0,0,0,0);
    animation-name: fadeIn;
    animation-duration: 0.4s;
    animation-fill-mode: both;
    .dice {
        position: absolute;
        width: 200px;
        height: 200px;
        left: 50%;
        margin-left: -100px;
        top: 11.4rem;
        opacity: 0;
        z-index: 2;
        transform: scale(0.24);
        perspective:2000px;
        &.moving {
            top: 5rem;
            opacity: 1;
            transform: scale(1) rotate(720deg);
        }
    }

    ul {
        position: relative;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;
        transform:rotateX(45deg) rotateY(45deg);
        transition: all 0.8s ease-out;

        li {
            position: absolute;
            width:100%;
            height:100%;
            left: 0px;
            top: 0px;
            border: 1px solid #f6e03a;
            box-sizing: border-box;
            background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
            background-repeat: no-repeat;
            &:nth-of-type(1) {
                transform: rotateX(90deg) translateZ(100px);
                background-position: 0px -1288px;
            }

            &:nth-of-type(2) {
                background-position: -233px -1288px;
                transform: translateZ(-100px);
            }

            &:nth-of-type(3) {
                background-position: -467px -1288px;
                transform: rotateX(90deg) translateZ(-100px);
            }

            &:nth-of-type(4) {
                background-position: -699px -1288px;
                transform: translateZ(100px);
            }

            &:nth-of-type(5) {
                background-position: -933px -1288px;
                transform: rotateY(90deg) translateZ(100px);
            }

            &:nth-of-type(6) {
                background-position: -1167px -1288px;
                transform: rotateY(90deg) translateZ(-100px);
            }
        }
    }

    .btn {
        color: #fff;
        width: 4rem;
        text-align: center;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.32rem;
        letter-spacing: 0.32em;
        margin: 0rem auto;
        z-index: 3;
        position: relative;
        border: 1px solid #fff;
    }

    .panel {
        position: absolute;
        z-index: 0;
        width: 4.62rem;
        height: 3.16rem;
        left: 50%;
        margin-left: -2.3rem;
        top: 5.50rem;
        animation-fill-mode: both;
        animation-name: fadeIn;
        animation-duration: 0.4s;

        div {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0rem;
            top: 0rem;
            @extend .icon;
            background-position: -3.17rem -15.42rem;
            animation-duration: 2s;
            animation-name: Bigger;
            animation-iteration-count: 2;

            &:nth-of-type(1) {
                opacity: 0.6;
                transform: scale(0.8);
                animation-delay: 0s;
            }

            &:nth-of-type(2) {
                opacity: 0.7;
                transform: scale(0.5);
            }

            &:nth-of-type(3) {
                opacity: 0.9;
                transform: scale(0.2);
            }
        }
    }
}
</style>